export const SIDEBAR_GROUPS = [
  {
    label: "LISTINGS",
    tabs: [
      { id: "listing", icon: "🏠", label: "MLS Listing" },
      { id: "openhouse", icon: "🚪", label: "Listing Tools" },
      { id: "sellerupdate", icon: "📊", label: "Seller Update" },
      { id: "cma", icon: "📊", label: "CMA" },
      { id: "propinfo", icon: "🏠", label: "Property Info" },
    ],
  },
  {
    label: "AGENT TOOLS",
    tabs: [
      { id: "followup", icon: "✉️", label: "Follow-Up" },
      { id: "contract", icon: "📋", label: "Contract" },
      { id: "inspection", icon: "🔍", label: "Inspection" },
      { id: "bio", icon: "👤", label: "Bio" },
      { id: "expired", icon: "📋", label: "Expired" },
      { id: "fsbo", icon: "📤", label: "FSBO" },
      { id: "offer", icon: "📨", label: "Offer Summary" },
      { id: "contacts", icon: "👥", label: "Contacts" },
    ],
  },
];
export const TONES = ["Luxury", "Cozy", "Investment", "Family", "Modern", "Minimalist"];
export const BUYER_STAGES = ["Just looking", "Casually browsing", "Actively searching", "Ready to buy"];
